export function runBrowserPrint() {
  try {
    document.execCommand("print", false);
  } catch {
    window.print();
  }
}
